'use strict';

var ngModule = 'frontend.performanceReview';

require('angular')
  .module(ngModule, [ require('./performance-review-invite') ])
  .factory('performanceReviewService', require('./service/performance-review'))
  .component('performanceReviewAgreementReviewLock', require('./performance-review-agreement-lock'))
  .component('performanceReviewRound', require('./performance-review-round'))
  .component('performanceReviewQuestionnaire', require('./performance-review-questionnaire'))
  .component('performanceReviewSummary', require('./performance-review-summary'))
  .component('performanceReviewBasis', require('./performance-review-basis'))
  .component('performanceReviewNavigation', require('./performance-review-navigation'))
  .component('performanceReviewDistribution', require('./performance-review-distribution'))
  .component('performanceReviewAgreementQuestionnaire', require('./performance-review-agreement-questionnaire'))
  .component('performanceReviewAgreementSummary', require('./performance-review-agreement-summary'))
  .component('performanceReviewIntro', require('./performance-review-intro'))
  .component('performanceReviewOverview', require('./performance-review-overview'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/index.js
 ** module id = 245
 ** module chunks = 0
 **/